import { axiosBitrixInstance } from "../../utils/axios/requestInfo";
import { generateGuid } from "../../helpers/generateGuid";
import { getMoscowDate } from "../../helpers/dateFormatter";
import { api } from "../../resources/api";
import { 
  IBitrixActiveCourtsResponse, 
  IBitrixDailyScheduleResponse,
  IBitrixCourt,
  IBitrixScheduleItem,
  IBitrixRentInfo
} from "./bitrixArenasTypes";

const DEFAULT_PARTNER_ID = '79a3b7f5-20ec-11eb-80c3-ac1f6bb3f7d3';

export interface IReserveItem {
  courtId: string;
  startTime: string;
  finishTime: string;
}

export interface ICreateCancelRentParams {
  partnerId: string;
  newReserve: IReserveItem[];
  cancelReserve: IReserveItem[];
}

export const getDailySchedule = async (
  partnerId: string | null | undefined,
  date: string
): Promise<IBitrixDailyScheduleResponse> => {
  try {
    const finalPartnerId = partnerId || DEFAULT_PARTNER_ID;
    
    const encodedDate = encodeURIComponent(date);
    
    const url = api.bitrix.GET_DAILY_SCHEDULE(finalPartnerId, encodedDate);
    
    const response = await axiosBitrixInstance.get<IBitrixDailyScheduleResponse>(url);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const getActiveCourts = async (): Promise<IBitrixActiveCourtsResponse> => {
  try {
    const response = await axiosBitrixInstance.get<IBitrixActiveCourtsResponse>(api.bitrix.GET_ACTIVE_COURTS);
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const createReserveArena = async (
  params: ICreateCancelRentParams
): Promise<any> => {
  try {
    const arenaId = params.newReserve[0]?.courtId || '';
    const guid = generateGuid({
      phone: params.partnerId,
      name: arenaId,
      email: new Date().toISOString(),
    });

    const response = await axiosBitrixInstance.post(
      api.bitrix.CREATE_CANCEL_RENT,
      {
        partnerId: params.partnerId,
        changeDate: getMoscowDate(),
        guid: guid,
        newReserve: params.newReserve,
        cancelReserve: params.cancelReserve || [],
      }
    );

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const cancelReserveArena = async (
  params: ICreateCancelRentParams
): Promise<any> => {
  try {
    const arenaId = params.cancelReserve[0]?.courtId || '';
    const guid = generateGuid({
      phone: params.partnerId,
      name: arenaId,
      email: new Date().toISOString(),
    });

    const response = await axiosBitrixInstance.post(
      api.bitrix.CREATE_CANCEL_RENT,
      {
        partnerId: params.partnerId,
        changeDate: getMoscowDate(),
        guid: guid,
        newReserve: params.newReserve || [],
        cancelReserve: params.cancelReserve,
      }
    );

    return response.data;
  } catch (error: any) {
    throw error;
  }
};

